import * as React from 'react';

const TableFooterLoader: React.FC = () => (
    <div className="table-footer-overlay-loader">
        <div className="custom-loading-overlay">
            <div className="spinner">
                <div className="double-bounce1" />
                <div className="double-bounce2" />
            </div>
        </div>
    </div>
);

export default TableFooterLoader;



// WEBPACK FOOTER //
// ./src/components/Table/components/footerComponents/TableFooterLoader.tsx